const convertPhoneNumber = (phoneNumber) => {
  if (typeof phoneNumber !== 'string' || phoneNumber.length !== 10 || !/^\d+$/.test(phoneNumber)) {
    return null;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6)}`;
}

export {
  convertPhoneNumber
};